// src/components/Public/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaHome } from 'react-icons/fa';

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Property Listings</title>
        <meta name="description" content="The page you're looking for doesn't exist. Browse our available properties or return to the homepage." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <div style={containerStyle}>
        <div style={notFoundStyle}>
          <h1 style={notFoundTitleStyle}>404 - Page Not Found</h1>
          <p style={notFoundTextStyle}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <div style={notFoundLinksStyle}>
            <Link to="/" style={primaryButtonStyle}>
              <FaHome style={{ marginRight: '8px' }} />
              Go Home
            </Link>
            <Link to="/" style={secondaryButtonStyle}>
              Browse Properties
            </Link>
          </div>

          <div style={suggestionSectionStyle}>
            <h3>You might be interested in:</h3>
            <div style={suggestionLinksStyle}>
              <Link to="/category/condo" style={suggestionLinkStyle}>Condos</Link>
              <Link to="/category/apartment" style={suggestionLinkStyle}>Apartments</Link>
              <Link to="/category/landed-house" style={suggestionLinkStyle}>Landed Houses</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// Styles
const containerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '20px',
};

const notFoundStyle = {
  textAlign: 'center',
  padding: '80px 20px',
  maxWidth: '600px',
  margin: '0 auto',
};

const notFoundTitleStyle = {
  fontSize: '3em',
  color: '#333',
  marginBottom: '20px',
};

const notFoundTextStyle = {
  fontSize: '1.2em',
  color: '#666',
  marginBottom: '30px',
};

const notFoundLinksStyle = {
  display: 'flex',
  gap: '15px',
  justifyContent: 'center',
  marginBottom: '40px',
  flexWrap: 'wrap',
};

const primaryButtonStyle = {
  padding: '12px 24px',
  backgroundColor: '#007bff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '8px',
  fontSize: '1.1em',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  transition: 'background-color 0.3s ease',
};

const secondaryButtonStyle = {
  padding: '12px 24px',
  backgroundColor: 'transparent',
  color: '#007bff',
  textDecoration: 'none',
  border: '2px solid #007bff',
  borderRadius: '8px',
  fontSize: '1.1em',
  fontWeight: 'bold',
  transition: 'all 0.3s ease',
};

const suggestionSectionStyle = {
  marginTop: '40px',
  padding: '30px',
  backgroundColor: '#f8f9fa',
  borderRadius: '10px',
};

const suggestionLinksStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
  justifyContent: 'center',
  marginTop: '20px',
};

const suggestionLinkStyle = {
  padding: '8px 16px',
  backgroundColor: '#007bff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '20px',
  fontSize: '0.9em',
  fontWeight: 'bold',
  transition: 'background-color 0.3s ease',
};

export default NotFound;